import script from "./EmployeeHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeHome.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeHome.vue?vue&type=style&index=0&id=a4515eca&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4515eca"]])

export default __exports__